import styled from 'styled-components/macro';
import { Flex } from 'rebass/styled-components';
import { get } from 'lodash';

import { rem } from '@blueprint/ui';

import { colors } from 'themes';

const answerBackgroundColor = get(colors, 'formElements.12');

export const BaseContentBox = styled(Flex)`
  max-width: ${rem(360)};
  background-color: ${answerBackgroundColor};
  padding: ${rem(8)};
  border-radius: ${rem(4)} ${rem(4)} ${rem(4)} 0;
  margin-right: ${rem(16)};
`;
